import { useEffect } from 'react';

function useVersionChecker() {
    useEffect(() => {
        const interval = setInterval(async () => {
            const response = await fetch('/version.json');
            const { version: newVersion } = await response.json();
            const currentVersion = localStorage.getItem('appVersion');

            if (currentVersion && currentVersion !== newVersion) {
                console.log('New version available. Reloading...');
                window.location.reload(); // Trigger a refresh
            } else {
                localStorage.setItem('appVersion', newVersion);
            }
        }, (60000)); // Check every 30 seconds

        return () => clearInterval(interval);
    }, []);
}

export default useVersionChecker;